import { httpAdminReport } from "../helper/http-common";
class GlobalGemstoneReportService {
    GetRetailers(inputData) {
        return httpAdminReport.post("/GemstoneReport/GetRetailers", inputData)
    }
    GetVendors(inputData) {
        return httpAdminReport.post("/GemstoneReport/GetVendors", inputData)
    }
    GetRetailersOnVendorDropdownChange(inputData) {
        return httpAdminReport.post("/GemstoneReport/GetRetailersOnVendorDropdownChange", inputData)
    }
    GetVendorsOnRetailerDropdownChange(inputData) {
        return httpAdminReport.post("/GemstoneReport/GetVendorsOnRetailerDropdownChange", inputData)
    }
    // ChangeVendorList(inputData) {
    //     return httpAdminReport.post("/Admin_JewelryReport/Bind_VendorDetails", inputData)
    // }
    CheckDealermembers(inputData) {
        return httpAdminReport.post("/Admin_JewelryReport/CheckDealermembers", inputData);
    }
    GemstoneChartForCutGrade(inputData) {
        return httpAdminReport.post("/GemstoneReport/GemstoneChartForCutGrade", inputData);
    }
    LoadChartReports(inputData) {
        return httpAdminReport.post("/GlobalGemstoneReport/LoadChartReports", inputData);
    }
    ExportActivityPdf(inputData) {
        return httpAdminReport.post("/GlobalGemstoneReport/ExportActivityPdf", inputData, {
            responseType: "arraybuffer",
        });
    }
    ExportMetricPdf(inputData) {
        return httpAdminReport.post("/GlobalGemstoneReport/ExportMetricPdf", inputData, {
            responseType: "arraybuffer",
        });
    }
    // Global Gemstone Charts page - its on-screen data comes from the
    // /GemstoneReport endpoints (GetGemstoneColumnChartData etc.), so its
    // PDF does too (reportName "GlobalVendor").
    ExportVendorMetricPdf(inputData) {
        return httpAdminReport.post("/GemstoneReport/ExportMetricPdf", inputData, {
            responseType: "arraybuffer",
        });
    }
    GetGemstoneReportForTableChartAll(inputData) {
        return httpAdminReport.post("/GemstoneReport/GetGemstoneReportForTableChartAll", inputData);
    }
    GetGemstoneColumnChartData(inputData) {
        return httpAdminReport.post("/GemstoneReport/GetGemstoneColumnChartData", inputData);
    }
    GetGemstoneReportForTableChart(inputData) {
        return httpAdminReport.post("/GemstoneReport/GetGemstoneReportForTableChart", inputData);
    }
    GemstoneChart_SortingBindData(inputData) {
        return httpAdminReport.post("/GemstoneReport/GemstoneChart_SortingBindData", inputData);
    }
    ExportToCSV(inputData) {
        return httpAdminReport.post("/GemstoneReport/ExportToCSV", inputData, {
            responseType: "arraybuffer",
        });
    }
    ExportTableDataToPDF(inputData) {
        return httpAdminReport.post(
            "/GemstoneReport/GetGemstoneReportForTableChart_PDF",
            inputData,
            {
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf",
                },
            }
        );
    }
}

export default new GlobalGemstoneReportService();
